import { StoreCalendarType } from 'types/storeCalendar'
import { useMemo } from 'react'

const useGetTemporaryOpen = (date: string, storeCalendars: StoreCalendarType[]): StoreCalendarType | undefined => {
  return useMemo(() => {
    return storeCalendars.find((storeCalendar) => {
      return storeCalendar.status === 'open' && storeCalendar.date === date
    })
  }, [storeCalendars, date])
}

export default useGetTemporaryOpen
